// 홍보물월정산 공용 헬퍼 — 본체(테이블)와 모바일 카드가 함께 사용.
// 금액 입력은 type=text + inputMode=numeric (스피너 화살표 금지 규칙).
import React from 'react';

export const MONEY_FIELDS = ['management_fee', 'dining_amount', 'usim_amount', 'sales_amount', 'etc_amount'];

// 입력 필드 한국어 라벨 (테이블 헤더와 동일 표기)
export const MONEY_FIELD_LABELS = {
  management_fee: '관리비',
  dining_amount: '회식*(1/2)',
  usim_amount: '유심',
  sales_amount: '영업*1.1',
  etc_amount: '기타',
};

export function formatNumber(value) {
  const n = Number(value || 0);
  return Number.isFinite(n) ? n.toLocaleString('ko-KR') : '0';
}

export function formatMoneyInput(value) {
  if (value === '' || value == null) return '';
  const text = String(value).replace(/,/g, '').trim();
  if (text === '-' || text === '') return text;
  const sign = text.startsWith('-') ? '-' : '';
  const digits = text.replace(/^-/, '').replace(/\D/g, '');
  if (!digits) return sign;
  return `${sign}${Number(digits).toLocaleString('ko-KR')}`;
}

export function normalizeMoneyTyping(value) {
  const text = String(value || '').replace(/,/g, '').trim();
  if (text === '-' || text === '') return text;
  const sign = text.startsWith('-') ? '-' : '';
  const digits = text.replace(/^-/, '').replace(/\D/g, '');
  return digits ? formatMoneyInput(`${sign}${digits}`) : sign;
}

export function toDraft(row) {
  return {
    management_fee: formatMoneyInput(row.management_fee),
    dining_amount: formatMoneyInput(row.dining_amount),
    usim_amount: formatMoneyInput(row.usim_amount),
    sales_amount: formatMoneyInput(row.sales_amount),
    etc_amount: formatMoneyInput(row.etc_amount),
  };
}

// 확정 단추 한 벌 (PC 표·휴대폰 카드 공용, 2026-10-02 사용자 요청 "확정버튼 다시 누르면 활성화")
//   확정 전 = '확정' / 확정·정산 전 = '확정 취소'(누르면 확정이 풀려 다시 입력 가능) / 정산완료 = '확정됨' 꺼짐
//   (정산완료는 되돌리는 기능이 없어 확정도 그대로 둔다). 처리 중에는 확정·확정 취소 둘 다 잠근다(두 번 눌림 방지).
export function confirmButtonState(row, busyKey) {
  const ym = row.year_month;
  const busy = busyKey === `${ym}:confirm` || busyKey === `${ym}:reopen`;
  if (row.is_settled) {
    return { action: null, label: '확정됨', disabled: true, title: '정산완료된 월은 확정을 취소할 수 없습니다.' };
  }
  if (row.is_confirmed) {
    return { action: 'reopen', label: '확정 취소', disabled: busy, title: '확정을 풀고 다시 고칠 수 있게 합니다.' };
  }
  return { action: 'confirm', label: '확정', disabled: busy, title: undefined };
}

export function MoneyInput({ value, onChange, disabled }) {
  return (
    <input
      className="pms-money-input"
      inputMode="numeric"
      disabled={disabled}
      value={value}
      onChange={(event) => onChange(normalizeMoneyTyping(event.target.value))}
    />
  );
}

export function ReadMoney({ value, sub }) {
  return (
    <div className="pms-read-money">
      <strong>{formatNumber(value)}</strong>
      {sub ? <span>{sub}</span> : null}
    </div>
  );
}
